

export namespace OBCustomerAnswerConst {
  export const IDCTypeConst = [
    {code: 'SAMPLING', nameEn: 'Sampling', nameVi: 'Mẫu'},
    {code: 'NEGATIVE', nameEn: 'Negative', nameVi: 'Tiêu cực'},
    {code: 'NORESPONSE', nameEn: 'No response', nameVi: 'Không phản hồi'},
  ]
}